import React, { Component } from "react";
import { Button, Form, Image,  } from "react-bootstrap";
import configData from "../config.json";
import { toast } from "react-toastify";
import Aadhaar from "./Aadhaar.png";
import mobile from "./mobile.png";
import "./Abha.css";
import ReCAPTCHA from 'react-google-recaptcha';

export default class Abhaaddressverification extends Component {
  constructor(props) {
    super(props);
   this.recaptchaRef = React.createRef();
    this.state = {
      requestId: sessionStorage.getItem("requestId"),
      abhaAddress: sessionStorage.getItem("abhaAddress")||"",
      abhaotp: ["", "", "", "", "", ""],
      abhaaddressotp: ["", "", "", "", "", ""],
      AbhaProfile: {},
      otpResponseMsg: "",
      mobile: "",
      showOtp: false,
      showAbha: false,
      showAbhaAddress: false,
      showAddessotp: false,
      cabhaaddress: "",
      custshowAddess: false,
      isAbhaVerifiedReady: false,
      authMethods: "",
      resendTimer: 60, // 10 minutes
      resendEnabled: false,
      resendIntervalId: null,
      captchaToken:null,
      // ["aadhaarotp", "mobileotp"]
    };
  }
  handleCaptchaChange = (value) => {
    this.setState({
      captchaToken: value,
    });
  };
  resetCaptcha = () => {
    this.setState({ captchaToken: "" });
    if (this.recaptchaRef && this.recaptchaRef.current) {
      this.recaptchaRef.current.reset();
    }
  };
 ResponseHandler = () => {
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
  
    fetch(configData.api_url + "C_Abhadetails/retriverequestId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (
          data.status === "success" &&
          data.detail &&
          data.detail.abhaprofile
        ) {
          try {
            const abhaDetails = JSON.parse(data.detail.abhaprofile);
            const abhaProfile = abhaDetails.ABHAProfile;
            if (abhaProfile) {
              this.setState({
                AbhaProfile: abhaProfile,
              });
            }
          } catch (err) {
            console.error("Invalid JSON in abhaprofile:", err);
            toast.error("Failed to load ABHA profile. Please try again.");
          }
        } else {
          console.warn("abhaprofile is missing in API response");
          toast.error("ABHA profile not available in response.");
        }
      })
      .catch((err) => {
        console.error("Error fetching ABHA profile:", err);
        toast.error("Something went wrong while loading profile.");
      });
  };
  
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
       case "warning":
      toast.danger(msg);
        break;
     default:toast.success(msg);
    }
  };
  handleImageClick = (option) => {
    this.setState({ authMethods: option });
  };

  handleabhaaddressotpChange = (e, index) => {
    const val = e.target.value;
    if (/^\d?$/.test(val)) {
      this.setState(
        (prevState) => {
          const newOtp = [...prevState.abhaaddressotp];
          newOtp[index] = val;
          return { abhaaddressotp: newOtp };
        },
        () => {
          // auto focus next input if a digit was entered
          if (val && index < 5) {
            this[`otpInput1${index + 1}`].focus();
          }
        }
      );
    }
  };

  handleABHAAddressSearchNext = (e) => {
    e.preventDefault();
    const { abhaAddress, authMethods } = this.state;
    if (!authMethods) {
      this.showToast("Please select Aadhaar or Mobile OTP option.", "error");
      return;
    }
    sessionStorage.setItem("abhaAddress", abhaAddress);
    const formData = new FormData();
    formData.append("abhaAddress", abhaAddress);
    formData.append("authMethods", authMethods);
    formData.append("requestId", sessionStorage.getItem("requestId"));

    fetch(configData.api_url + "C_Abhadetails/getAuthMethodsByabhaAddress", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.showToast(data.message, data.status);
          sessionStorage.setItem("message", data.message);
          sessionStorage.setItem("resendOtpABAVeCount", "");
          this.setState({ isAbhaVerifiedReady: true }); // changed from data.details.message
        } else {
          this.showToast(data.message || "Something went wrong", "error");

          this.setState({
            resendOtpABAVeCount: "",
          });
        }
      });
  };
  handleABHAAddressSubmitNext = (e) => {
    e.preventDefault();
    const { abhaAddress, authMethods ,captchaToken} = this.state;

    sessionStorage.setItem("abhaAddress", abhaAddress);
    if (!captchaToken) {
       this.showToast('Please verify that you are not a robot!',"error");
      return;
    }
    const formData = new FormData();
    formData.append("abhaAddress", abhaAddress);
    formData.append("authMethods", authMethods);
    formData.append("captchaToken", captchaToken);
    formData.append("requestId", sessionStorage.getItem("requestId"));

    fetch(configData.api_url + "C_Abhadetails/submitAbhaAddress", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({
            otpResponseMsg: data.details.message, // store message for <p> tag
            responseMessage: "",
            showMessage: false,
          });

          sessionStorage.setItem("otpResponseMsg",data.details.message)
          this.showToast(data.message, "success");
          window.location.href = "/abhaaddressverificationotp";
        } else {
          this.setState({
            responseMessage: data?.details?.message || data.message,
            showMessage: true,
          });
          this.showToast(data.message || "Something went wrong", "error");
        }
      })
     
  };

  handleSubmitAddressOTPNext = (e) => {
    e.preventDefault();
    const {captchaToken}=this.state
    const abhaaddressotp = this.state.abhaaddressotp.join("");
    if (!captchaToken) {
       this.showToast('Please verify that you are not a robot!',"error");
      return;
    }
    sessionStorage.setItem("abhaotp", this.state.abhaaddressotp);
    var formData = new FormData();
    formData.append("captchaToken", captchaToken);
    formData.append("abhaaddressotp", abhaaddressotp);
    formData.append("requestId", sessionStorage.getItem("requestId"));

    fetch(configData.api_url + "C_Abhadetails/submitAbhaAddressOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            resendOtpABAVeCount: "",
          });
        }
        // else {
        //    this.showToast(data.message||"OTP verification failed. Please check your OTP and try again.");
        // }
        if (this.recaptchaRef && this.recaptchaRef.current) {
          this.recaptchaRef.current.reset(); // ✅ Reset after submission
        }
      });
  };

  onKeyDownONE = (e, idx) => {
    if (e.key === "Backspace" && !this.state.abhaaddressotp[idx] && idx > 0) {
      this[`otpInput1${idx - 1}`].focus();
    }
  };
  handleabhaaddressChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ abhaAddress: fieldValue });
  };

  HandleClick = () => {
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/retriveAbhacard", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
        if (data.status === "success") {
        }
        this.setState({
          isSubmitting: false,
        });
      });
  };

  HandleNextSubmit = () => {
    window.location.href = "/abhaprofile";
  };
  HandleNewClick = () => {
    const { abhaAddress, abhanumber } = this.state;
    sessionStorage.setItem("abhaAddress", abhaAddress);
   
    sessionStorage.setItem("abhanumber", abhanumber);

    window.location.href = "/abhacreation";
  };
  handlenextClick = () => {
    const { abhanumber, aadharNumber } = this.state;
    sessionStorage.setItem("abhaAddress", this.state.AbhaProfile.phrAddress);
    sessionStorage.setItem("aadharNumber", aadharNumber);
    sessionStorage.setItem("abhanumber", abhanumber);

    window.location.href = "/abhaprofile ";
  };

  render() {
    const {
      showAbhaAddress,
      abhaAddress,
      authMethods,
     
    } = this.state;
    return (
      <div>
      

        <div className="row justify-content-md-center text-center abhaAddressVerificationSection">
          <div className="col-md-6 mt-3">
            <div className="widget_BG widget_BG_grid mb-2">
              <Form.Group>
                <Form.Label>
                  <b>ABHA Address</b>
                </Form.Label>
                <div className="d-flex gap-2">
                  <Form.Control
                    type={showAbhaAddress ? "text" : "password"}
                    value={abhaAddress}
                    onChange={this.handleabhaaddressChange}
                    className="form-control"
                    placeholder="Enter ABHA Address"
                    onKeyDown={this.onKeyDown}
                  />

                  <Button
                    variant="outline-secondary"
                    className={`rounded-0 bi ${
                      showAbhaAddress ? "bi-eye-slash" : "bi-eye"
                    }`}
                    onClick={() =>
                      this.setState({ showAbhaAddress: !showAbhaAddress })
                    }
                  />
                </div>

                <div className="row justify-content-md-center mt-3 selectAadhaarMobileOtp">
                  <p>Validate using</p>

                  <div className="col text-center">
                    <div
                      onClick={() => this.handleImageClick("aadhaarotp")}
                      style={{
                        border:
                          authMethods === "aadhaarotp"
                            ? "2px solid blue"
                            : "1px solid #ccc",
                        padding: "10px",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                    >
                      <Image
                        src={Aadhaar}
                        className=""
                        alt="Aadhaar"
                        style={{
                          // width: "",
                          height: "44px",
                          marginBottom: "5px",
                        }}
                      />
                      <Form.Check
                        label="Aadhaar OTP"
                        name="otpMethod"
                        type="radio"
                        disabled
                        checked={authMethods === "aadhaarotp"}
                      />
                    </div>
                  </div>

                  <div className="col text-center ">
                    <div
                      onClick={() => this.handleImageClick("mobileotp")}
                      style={{
                        border:
                          authMethods === "mobileotp"
                            ? "2px solid blue"
                            : "1px solid #ccc",
                        padding: "10px",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                    >
                      <Image
                        src={mobile}
                        className=""
                        alt="Mobile"
                        style={{
                          width: "auto",
                          height: "44px",
                          marginBottom: "5px",
                        }}
                      />
                      <Form.Check
                        label="Mobile OTP"
                        name="otpMethod"
                        type="radio"
                        disabled
                        checked={authMethods === "mobileotp"}
                      />
                    </div>
                  </div>
                </div>
            
                <div className="col mt-3">
                            
                            <div className="d-flex">   <ReCAPTCHA 
                    className="mt-4"
                    ref={this.recaptchaRef} 
                    sitekey= {configData.captchaKey}
                    onChange={this.handleCaptchaChange}
                    /> 
                    <Button variant="secondary"  className="bi bi-arrow-clockwise re-chaptue" 
                            onClick={() => this.recaptchaRef.current.reset()}/>
                    </div>
                               
                            </div>
                
              </Form.Group>
                {this.state.otpResponseMsg && (
              <p style={{ color: "green", fontWeight: "bold" }}>
                {this.state.otpResponseMsg}
            </p>
          )}
           
            </div>
          </div>
        </div>
        <div className="row  widget_BG widget_BG_grid m-0 mt-2">
        <div className="col text-start">
        <Button className="rounded-0 m-1" onClick={this.HandleNewClick}>
              Back
            </Button>
            </div>
          <div className="col text-end">
            
          <Button
               
               className="rounded-0 m-3"
               onClick={this.handleABHAAddressSubmitNext}
             >
               Verify ABHA Address
             </Button>
          </div>
        </div>
      </div>
    );
  }
}
